export default [
  {
    path: '/tenant',
    name: 'tenant',
    redirect: '/tenant/stats/fallRecord',
    meta: {
      title: '租户统计',
      isFullScreen: false,
      keepAlive: false,
      hidden: true,
      prem: true,
    },
    children: [
      {
        path: '/tenant/stats/fallRecord',
        name: 'tenantStatsFallRecord',
        component: () => import('@/views/tenant/stats/fallRecord/index.vue'),
        meta: {
          title: '跌倒历史',
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
    ],
  },
]
